export const CA = "8nJpiH4Rdun9YeEquFLVD9X8y6Pat36HHr4DCmhDpump";
export const BUY_URL = `https://dexscreener.com/solana/${CA}`;
export const CHART_EMBED_URL = `https://dexscreener.com/solana/${CA}?embed=1&theme=light&trades=0&info=0`;
export const TELEGRAM_URL = "https://t.me/Bluewhalecoincommunitypump";
export const X_URL = "https://x.com/jirovecsim";
export const SUPPLY = "1,000,000,000";
export const INTRO_MS = 1500;
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
